import { render } from "./OrderDetailsLocation.vue?vue&type=template&id=1481af60"
import script from "./OrderDetailsLocation.vue?vue&type=script&lang=js"
export * from "./OrderDetailsLocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__